const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllAnaliticas() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/analiticas`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAnaliticasByID(postId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/analiticas/${postId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllAnaliticasByTax(taxId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/analiticas?tratamiento=${taxId}&per_page=99`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}
